export default __webpack_public_path__ + "static/media/asistente.95cab736.png";